import { NgModule } from '@angular/core';
import { CommonModule as NgCommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { DismissComponent } from './dismiss/dismiss.component';
import { ApplicationProgressComponent } from './application-progress/application-progress.component';
import { JobInfoBriefComponent } from './job-info-brief/job-info-brief.component';
import { WorkingDaysOfWeekComponent } from './working-days-of-week/working-days-of-week.component';
import { GoogleMapsComponent } from './google-maps/google-maps.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { JobBriefModalComponent } from './job-brief-modal/job-brief-modal.component';
import { PhoneMaskDirective } from '../util/phone-mask.directive';
import { PreventSpaceDirective } from '../util/prevent-space.directive';
import { SSNMaskDirective } from '../util/ssn-mask.directive';
import { AdvanceInputOnEnterDirective } from '../util/advance-input-on-enter.directive';
import { InvalidEmailComponent } from './invalid-email/invalid-email.component';
import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';
import { AlertComponent } from './alert/alert.component';
import { SuccessModalComponent } from './success-modal/success-modal.component';
import { ScheduleDetailComponent } from './schedule-detail/schedule-detail.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { SingleReviewComponent } from './single-review/single-review.component';
import { InvalidJobModalComponent } from '../application-home/invalid-job-modal/invalid-job-modal.component';
import { JobInfoCardComponent } from './job-info-card/job-info-card.component';
import { PipeModule } from '../pipes/pipe.module';
import { BadgeComponent } from './badge/badge.component';
import { NoJobsComponent } from './no-jobs/no-jobs.component';
import { JobRequirementsComponent } from './job-requirements/job-requirements.component';
import { JobHeaderComponent } from './job-header/job-header.component';
import { CodeInputModule } from 'angular-code-input';
import { VerificationCodeModalComponent } from './verification-code-modal/verification-code-modal.component';
import { WarningModalComponent } from './warning-modal/warning-modal.component';
import { GettingThereComponent } from './getting-there/getting-there.component';
import { ScheduleJobShiftDatesComponent } from './schedule-job-shift-dates/schedule-job-shift-dates.component';
import { ScheduleJobShiftTimesComponent } from './schedule-job-shift-times/schedule-job-shift-times.component';
import { JobArrivalInstructionsComponent } from './job-arrival-instructions/job-arrival-instructions.component';
import { JobAdditionalInformationComponent } from './job-additional-information/job-additional-information.component';
import { WarnErrorComponent } from './warn-error/warn-error.component';
import { RouterModule } from '@angular/router';
import { StarRatingComponent } from './star-rating/star-rating.component';
import { SelectableChipComponent } from './selectable-chip/selectable-chip.component';
import { AppStoreButtonsComponent } from './app-store-buttons/app-store-buttons.component';
import { BannerComponent } from './banner/banner.component';
import { BlueshiftListComponent } from './blueshift-list/blueshift-list.component';
import { TimeToStartConfirmModalComponent } from './time-to-start-confirm-modal/time-to-start-confirm-modal.component';
import { BlueshiftScheduleDetailComponent } from './blueshift-schedule-detail/blueshift-schedule-detail.component';
import { CenterActionComponent } from './layouts/center-action/center-action.component';
import { LabelCheckboxComponent } from './label-checkbox/label-checkbox.component';
import { JobCommuteComponent } from './job-commute/job-commute.component';

@NgModule({
  declarations: [
    DismissComponent,
    ApplicationProgressComponent,
    AppStoreButtonsComponent,
    BlueshiftListComponent,
    BlueshiftScheduleDetailComponent,
    JobInfoBriefComponent,
    WorkingDaysOfWeekComponent,
    GoogleMapsComponent,
    ConfirmModalComponent,
    JobBriefModalComponent,
    PhoneMaskDirective,
    PreventSpaceDirective,
    SSNMaskDirective,
    AdvanceInputOnEnterDirective,
    InvalidEmailComponent,
    NavigationBarComponent,
    AlertComponent,
    SuccessModalComponent,
    ScheduleDetailComponent,
    InfoModalComponent,
    SingleReviewComponent,
    InvalidJobModalComponent,
    JobInfoCardComponent,
    BadgeComponent,
    NoJobsComponent,
    JobRequirementsComponent,
    JobHeaderComponent,
    VerificationCodeModalComponent,
    WarningModalComponent,
    GettingThereComponent,
    JobArrivalInstructionsComponent,
    JobAdditionalInformationComponent,
    ScheduleJobShiftDatesComponent,
    ScheduleJobShiftTimesComponent,
    TimeToStartConfirmModalComponent,
    WarnErrorComponent,
    StarRatingComponent,
    SelectableChipComponent,
    BannerComponent,
    CenterActionComponent,
    LabelCheckboxComponent,
    JobCommuteComponent,
  ],
  exports: [
    DismissComponent,
    ApplicationProgressComponent,
    AppStoreButtonsComponent,
    BlueshiftListComponent,
    BlueshiftScheduleDetailComponent,
    JobInfoBriefComponent,
    WorkingDaysOfWeekComponent,
    GoogleMapsComponent,
    ConfirmModalComponent,
    JobBriefModalComponent,
    PhoneMaskDirective,
    PreventSpaceDirective,
    SSNMaskDirective,
    AdvanceInputOnEnterDirective,
    InvalidEmailComponent,
    NavigationBarComponent,
    AlertComponent,
    SuccessModalComponent,
    ScheduleDetailComponent,
    InfoModalComponent,
    SingleReviewComponent,
    InvalidJobModalComponent,
    JobInfoCardComponent,
    BadgeComponent,
    NoJobsComponent,
    JobRequirementsComponent,
    JobHeaderComponent,
    VerificationCodeModalComponent,
    WarningModalComponent,
    GettingThereComponent,
    JobArrivalInstructionsComponent,
    JobAdditionalInformationComponent,
    ScheduleJobShiftDatesComponent,
    ScheduleJobShiftTimesComponent,
    TimeToStartConfirmModalComponent,
    WarnErrorComponent,
    StarRatingComponent,
    SelectableChipComponent,
    BannerComponent,
    CenterActionComponent,
    LabelCheckboxComponent,
    JobCommuteComponent,
  ],
  imports: [NgCommonModule, IonicModule, PipeModule, NgCircleProgressModule, CodeInputModule, RouterModule],
})
export class CommonModule { }
